import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  dataPointText: {
    marginLeft: '25px',
    marginRight: '15px',
    whiteSpace: 'pre-wrap',
    fontSize: '16px',
    fontWeight: 400,
  },
}));
